/**
 * 计算echarts的x轴的标签的interval值（视觉上比较合理的，不会出现紧凑拥挤导致文案展示错乱问题）
 * @param params 参数对象
 * @param params.canvasWidth echarts的canvas的宽度
 * @param params.gridLeft echarts的grid的left
 * @param params.gridRight ecahrts的grid的right
 * @param params.labelWidth echarts的x轴标签的宽度
 * @param params.firstLabelWidth echarts的x轴第一个标签的宽度
 * @param params.lastLabelWidth echarts的x轴最后一个标签的宽度
 * @param params.minSpacing echarts的x轴标签之间的最小间距
 * @param params.length echarts的x轴标签的个数
 * @returns echarts的x轴的标签的interval值（视觉上比较合理的，不会出现紧凑拥挤导致文案展示错乱问题）
 */
export const calcIntervalOfXAxisLabel = (params: {
  canvasWidth: number;
  gridLeft: number;
  gridRight: number;
  labelWidth: number;
  firstLabelWidth?: number;
  lastLabelWidth?: number;
  minSpacing?: number;
  length: number;
}): number => {
  const {
    canvasWidth = 0,
    gridLeft = 0,
    gridRight = 0,
    labelWidth = 0,
    firstLabelWidth = labelWidth,
    lastLabelWidth = labelWidth,
    minSpacing = labelWidth / 2,
    length = 0,
  } = params || {};

  if (!canvasWidth || !labelWidth || !length) return 0;
  if (length <= 2) return 0;

  const labelContainerWidth = canvasWidth - gridLeft - gridRight;
  const othersLabelContainerWidth = labelContainerWidth - (firstLabelWidth + lastLabelWidth + minSpacing * 2);

  const max = Math.round((othersLabelContainerWidth + minSpacing) / (labelWidth + minSpacing));

  return Math.max(Math.floor(length / max), 0);
};
